class NumericValidationOptions {
    public precision: number;
    public min: number;
    public max: number;
    public isNullAllowed?: boolean = true;
}

// ReSharper disable once Lambda
// tslint:disable-next-line
(ko.extenders as any).numeric = function (target: KnockoutObservable<number>, options: NumericValidationOptions): KnockoutComputed<number> {
    //create a writable computed observable to intercept writes to our observable
    var result = ko.pureComputed<number>({
        read: target,  //always return the original observables value
        // ReSharper disable once Lambda
        // ReSharper disable once MethodSafeThis
        write: function (newValue) {

            options = options || {} as NumericValidationOptions;
            var newValueAsString = newValue != null ? newValue.toString() : null;

            // Don't validate null values or directly set numbers
            if (newValue == null || typeof newValue === "number") {
                target(newValue);
                return;
            }

            var pattern = /^-?[0-9]*\.?[0-9]*$/;
            if (newValue != null && !pattern.test(newValueAsString)) {
                if (typeof result.setError != "undefined") {
                    result.clearError();
                    if (typeof result.isModified != "undefined") {
                        if (!result.isModified()) {
                            result.isModified(true);
                        }
                    }
                    result.setError("This field requires a numeric value");
                }
                return;
            }

            if (newValue != null && newValueAsString === "-") {
                // Don't set a value for just "-" - wait for the actual number to come in
                return;
                // ReSharper disable once TypeGuardProducesNeverType
            } else if ((typeof newValue === "string") && newValue === "") {
                newValue = null;
            }

            var current: number = target();
            var roundingMultiplier = (options != null && options.precision != null && options.precision === 0)
                ? 1
                : Math.pow(10, options != null ? (options.precision == null ? 10 : options.precision) : 10);
            // tslint:disable-next-line
            var newValueAsNum = isNaN(newValue as any) ? 0 : +newValue;
            var valueToWrite = newValue == null ? null : Math.round(newValueAsNum * roundingMultiplier) / roundingMultiplier;

            if (valueToWrite === null && !options.isNullAllowed) {
                if (typeof result.setError != "undefined") {
                    result.clearError();
                    if (typeof result.isModified != "undefined") {
                        if (!result.isModified()) {
                            result.isModified(true);
                        }
                    }
                    result.setError("A numeric value is required");
                }
                return;
            }

            // Check whole numbers
            if (roundingMultiplier === 1
                && newValue != null
                && newValueAsString !== ""
                && valueToWrite !== newValueAsNum) {
                // Whole numbers only
                if (typeof result.setError != "undefined") {
                    result.clearError();
                    if (typeof result.isModified != "undefined") {
                        if (!result.isModified()) {
                            result.isModified(true);
                        }
                    }
                    result.setError("This field requires whole numbers");
                }
                return;
            }

            // Check decimal places
            if (roundingMultiplier > 1
                && newValue != null
                && newValueAsString !== ""
                && valueToWrite !== newValueAsNum) {
                if (typeof result.setError != "undefined") {
                    result.clearError();
                    if (typeof result.isModified != "undefined") {
                        if (!result.isModified()) {
                            result.isModified(true);
                        }
                    }
                    result.setError(`This field accepts a maximum of ${options.precision} decimal place${options.precision > 1 ? "s" : ""}`);
                }
                return;
            }

            if (options != null) {
                if (options.min != null && valueToWrite != null && valueToWrite < options.min) {
                    if (typeof result.setError != "undefined") {
                        result.clearError();
                        if (typeof result.isModified != "undefined") {
                            if (!result.isModified()) {
                                result.isModified(true);
                            }
                        }
                        result.setError("This field requires a minimum value of " + options.min);
                    }
                    return;
                }
                if (options.max != null && valueToWrite != null && valueToWrite > options.max) {
                    if (typeof result.setError != "undefined") {
                        result.clearError();
                        if (typeof result.isModified != "undefined") {
                            if (!result.isModified()) {
                                result.isModified(true);
                            }
                        }
                        result.setError("This field requires a maximum value of " + options.max);
                    }
                    return;
                }
            }

            //only write if it changed
            var isPrefixValue = /^(\.|-|-0?\.?|0\.|-?0?\.0+)$/.test(newValueAsString);

            if (valueToWrite !== current && !isPrefixValue) {
                target(valueToWrite);
            } else {
                //if the rounded value is the same, but a different value was written, force a notification for the current field
                // tslint:disable-next-line
                if ((newValue as any !== current) && newValue != null && newValueAsString.length > 0) {
                    const lastCharacter = newValueAsString.substring(newValueAsString.length - 1);
                    if (newValueAsString !== "-" &&
                        lastCharacter !== "." &&
                        !(newValueAsString.indexOf(".") !== -1 && lastCharacter === "0")) {

                        target.notifySubscribers(valueToWrite);
                    }
                }
            }
        }
    }).extend({ notify: "always" });

    //initialize with current value to make sure it is rounded appropriately
    result(target());

    //return the new computed observable
    return result;
};

ko.validation.rules['url'] = {
    validator: function (val: string) {
        return /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test('' + val + '');
    },
    message: 'Please use a valid URL starting with http:// or https://'
};

ko.validation.rules['notSpecialChars'] = {
    validator: function (val: string) {
        var result = val.replace(/[^a-zA-Z0-9 ]/g, "");
        if (result.length < 3) {
            return false;
        }
        return true;
    },
    message: 'The field {0} must contain none special characters'
};

ko.validation.rules['guid'] = {
    validator: (val: string) => /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89ab][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/.test(val || ''),
    message: '{0} must be a valid Global Unique Identifier (GUID)'
};

ko.validation.rules['nullableGuid'] = {
    validator: (val: string) => (val || '').length === 0 || /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89ab][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/.test(val || ''),
    message: '{0} must be a valid Global Unique Identifier (GUID)'
};

ko.validation.registerExtenders();

//$(() => {
//    // tslint:disable-next-line
//    var button = (window as any).MaterialExtMenuButton;
//    var originalInit = button.prototype.init;
//    button.prototype.init = function () {
//        originalInit.apply(this, arguments);
//        debugger;
//        var menuButton = this.menuButton_;
//        var originalClickHandler = menuButton.closeHandler;
//        menuButton.closeHandler = function() {
//            if (this.element.getAttribute("data-keepopen") !== "true") {
//                originalClickHandler.apply(this, arguments);
//            }
//        };
//    };
//});

class KnockoutExtensions {
    public static numericObservable(value: number, options: NumericValidationOptions = null): KnockoutObservable<number> {
        // the observable we are extending
        var target = ko.observable<number>(value)
            .extend({
                number: true,
                numeric: options
            })
            .extend({ validatable: true });

        return target;
    }
    public static getTemplateByName(templateName: string): string {
        // tslint:disable-next-line
        var templateContainer = (ko as any).templates;
        var possibleTemplate = templateContainer != null ? templateContainer[templateName + "-html"] : null;
        if (possibleTemplate != null) {
            return possibleTemplate;
        }
        var possibleElement = document.getElementById(templateName);
        if (possibleElement != null) {
            return possibleElement.innerHTML;
        }

        return null;
    }

    public static pushAllToObservableArray<T>(targetObservableArray: KnockoutObservableArray<T>, valuesToPush: T[]) {
        var underlyingArray = targetObservableArray();
        targetObservableArray.valueWillMutate();
        ko.utils.arrayPushAll(underlyingArray, valuesToPush);
        targetObservableArray.valueHasMutated();
    }

    /**
     * Synchronises the selection in an MDL-EXT menu (i.e. renders a tick) in response to the value being updated programmatically
     * @param menuButtonId The id of the MDL-EXT menu
     * @param selectedValue The value that should be ticked as currently selected (as identified by the data-value attribute on the menu item)
     */
    public static syncMenuSelection(menuButtonId: string, selectedValue: string) {
        const $menuButton = $(`#${menuButtonId}`);
        if ($menuButton.length > 0) {
            // tslint:disable-next-line
            const menuApi = ($menuButton.get(0) as any).MaterialExtMenuButton;
            const menuElement: HTMLElement = menuApi.getMenuElement();
            const $menuItem = $(menuElement).find(`li[data-value='${selectedValue}']`);
            if ($menuItem.length > 0) {
                menuApi.setSelectedMenuItem($menuItem.get(0));
            }
        }
    }

    public static applyLineClamp(element: HTMLElement, maxHeight: number) {
        var $element = $(element);
        var originalContent = $element.data("line-clamp-original-content");
        if (originalContent != null) {
            $element.html(originalContent);
        } else {
            $element.data("line-clamp-original-content", $element.html());
            $element.attr("title", $element.text());
        }

        while (($element.get(0) as HTMLElement).offsetHeight >= maxHeight) {
            var contentBefore = $element.html();
            var contentAfter = $element.html().replace(/\W*\s(\S)*$/, "...");
            if (contentBefore === contentAfter) {
                break;
            }
            $element.html(contentAfter);
        }
    }

    public static windowSizeObservable = {
        windowHeight: ko.observable<number>(null),
        windowWidth: ko.observable<number>(null),
        windowDimensions: ko.observable<string>(null)
    };

}

/**
 * Sets error information on an observable such that the knockout validation system
 * will render it as a validation error in the UI for any bound controls.
 */
function setErrorOnObservable<T>(func: KnockoutSubscribableFunctions<T>, errorMessage: string) {
    if (typeof func.setError != "undefined") {
        func.clearError();
        if (typeof func.isModified != "undefined") {
            if (!func.isModified()) {
                func.isModified(true);
            }
        }
        func.setError(errorMessage);
        return;
    }
}

/*
 * Ensures a field has the same value as another field (E.g. "Confirm Password" same as "Password"
 * Parameter: otherField: the field to compare to
 * Example
 *
 * viewModel = {
 *   var vm = this;
 *   vm.password = ko.observable();
 *   vm.confirmPassword = ko.observable();
 * }   
 * viewModel.confirmPassword.extend( areSame: { params: viewModel.password, message: "Confirm password must match password" });
*/
// tslint:disable-next-line
ko.validation.rules["areSame"] = {
    // tslint:disable-next-line
    getValue(o: any) {
        return (typeof o === "function" ? o() : o);
    },
    // tslint:disable-next-line
    validator(val: any, otherField: any) {
        return val === this.getValue(otherField);
    },
    message: "The fields must have the same value"
    // tslint:disable-next-line
} as any;

ko.validation.rules["nutricalcPassword"] = {
    // tslint:disable-next-line
    validator(val: any) {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d ]).{8,}/.test("" + val + "");
    },
    message: "Password must be a minimum of 8 characters long and contain one number, one capital and one symbol "
};
    
if (!Element.prototype.closest)
    Element.prototype.closest = function (s: string) {
        var el = this;
        if (!document.documentElement.contains(el)) return null;
        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };

/* CustomEvent polyfill required for MDL-EXT on IE11 */
(() => {

    // tslint:disable-next-line
    if (typeof (window as any).CustomEvent === "function") return false;

    // tslint:disable-next-line
    function customEvent(event: Event, params: any) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent("CustomEvent");
        // tslint:disable-next-line
        (evt as any).initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    // tslint:disable-next-line
    customEvent.prototype = (window as any).Event.prototype;

    // tslint:disable-next-line
    (window as any).CustomEvent = customEvent;

})();

(() => {
    // tslint:disable-next-line
    $(window as any).on("pageshow", (event) => {
        // tslint:disable-next-line
        if ((event.originalEvent as any).persisted) {
            console.log("persisted load, reloading page");
            window.location.reload();
        }
    });

    // tslint:disable-next-line
    $(window as any).resize(() => {
        setTimeout(() => {
            // tslint:disable-next-line
            var $window = $(window as any);
            KnockoutExtensions.windowSizeObservable.windowHeight($window.height());
            KnockoutExtensions.windowSizeObservable.windowWidth($window.width());
            KnockoutExtensions.windowSizeObservable.windowDimensions(`${$window.width()}x${$window.height()}`);
        }, 1);
    });

    // tslint:disable-next-line
    (window as any)["windowSizeObservable"] = KnockoutExtensions.windowSizeObservable;
})();

export { KnockoutExtensions, NumericValidationOptions, setErrorOnObservable };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./Scripts/KnockoutExtensions/knockoutextensions.ts